import { getActualPageName, URL } from '../../utils/urlLibrary';

export const logInNeeded = () => {
  window.location.href = `#${URL.sessionExpired.hash}`;
}

export const goToLogin = () => {
  window.location.href = `#${URL.home.hash}`;
}

//  0: no hace nada
// -1: error controlado
// -2: error fatal
// -3: no tienes permisos para ver esto
// -4: Login
// -5: Mantenimiento
export const handlingCodes = {
  NOTHINGTODO: 0,
  CONTROLLED: -1,
  FATAL: -2,
  NOTALLOWED: -3,
  LOGIN: -4,
  MAINTENANCE: -5,
}


const detectUniversalError = (error) => {
  let handlingError = null;
  switch (error) {
    case 302:
    case 498: 
    case 401:
      handlingError = {
        handlingCode: handlingCodes.LOGIN,
      }
      break;
    case 500: 
      handlingError = {
        handlingCode: handlingCodes.CONTROLLED,
      }
      break;
    case 404: 
      handlingError = {
        handlingCode: handlingCodes.CONTROLLED,
      }
      break;
    case 598:
      handlingError = {
        handlingCode: handlingCodes.MAINTENANCE,
      }
      break;
    default:
      handlingError = {
        handlingCode: handlingCodes.NOTHINGTODO,
      }
      break;
  }
  return handlingError;
}

const getSpecificErrorHandler = (handleErrorsObj, error) => {
  const universalError = detectUniversalError(error);
  if (universalError) {
    return universalError;
  }
  // const errorStr = `code_${error}`;
  // if (!handleErrorsObj || typeof handleErrorsObj !== 'object') {
  //   return null;
  // }
  // if (handleErrorsObj[errorStr]) {
  //   return handleErrorsObj[errorStr];
  // }

  // return handleErrorsObj.default;
}

export const normalizeHttpErrors = (sagaName, error) => {
  let errorCode = 999;

  if (error.status) {
    errorCode = error.status;
  } else if (error.response && error.response.status) {
    errorCode = error.response.status;
  }

  // const handleSaga = errorHandleJSON[sagaName];
  // let actualPageName = getActualPageName();
  // actualPageName = actualPageName.id;
  // const handleErrorsObj = handleSaga ? handleSaga[actualPageName] : null;
  // const specificHandler = getSpecificErrorHandler(handleErrorsObj, errorCode);
  const specificHandler = getSpecificErrorHandler(null, errorCode);
  return specificHandler;
}

